// import { useWeb3React } from "@web3-react/core";
import { observer } from "mobx-react";
import React from "react";
import { PoolData } from "types";
import GlobalSection from "./GlobalSection/GlobalSection";
import UserInteractions from "./UserInteractions/UserInteractions";
import UserSection from "./UserSection/UserSection";
import "./Pool.scss";

type Props = {
  pool: PoolData;
};

function Pool({ pool }: Props) {
  return (
    <div className="item pool">
      <div className="item-content">
        <GlobalSection pool={pool} />
        <UserSection pool={pool} />
        <UserInteractions pool={pool} />
      </div>
    </div>
  );
}

export default observer(Pool);
